import {
    IonBackdrop, IonButton, IonCard, IonCardContent, IonCheckbox, IonChip, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonRadio, IonRadioGroup, IonRow, IonSelect,
    IonSelectOption, IonText, useIonViewWillLeave
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { User } from "../models/data";
import { translation } from "../models/translation";
import { createDonation } from "../services/donate_service";
import { fetchOrgList } from "../services/org_service";
import { ymd } from "../utlities/ymd";
import UserTerms from "./UserTerms";

interface Props {
    accountCredit: string | number | null,
    method?: string,
    stateData?: any | null,
    user: User
}

interface DonateForm {
    pickOrg: string | null,
    altOrg: string | null,
    date: string,
    freq: string,
    commission:number,
    amount: number,
    anom: boolean,
    beneficiary_type: string
}
const DonateComponent: React.FC<Props> = ({ user, accountCredit, method, stateData }) => {

    const history = useHistory();

    const siteText = translation();

    const [orgList, setOrgList] = useState<any[]>();


    const [disabled, setDisabled] = useState<boolean>(false);

    const [localState, setLocalState] = useState<any>();



    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;

    const [orgChoice, setOrgChoice] = useState({
        pickOrg: 'other',
    });

    const [donateData, setDonateData] = useState<DonateForm>({
        pickOrg: null,
        altOrg: null,
        date: minDate,
        freq: 'single',
        amount: 0,
        commission:0,
        anom: false,
        beneficiary_type: "other"
    })

    const [agreeToTerms, setAgreeToTerms] = useState<boolean>(false);

    const [showSubmiting, setShowSubmit] = useState<boolean>(false);

    const [transaction, setTransaction] = useState('processing');

    const commissions = [
        {
            name: 'basic',
            value: 0.03,
            label: '3%'
        },
        {
            name: 'middle',
            value: 0.05,
            label: '5%'
        },
        {
            name: 'basic',
            value: 0.07,
            label: '7%'
        }
    ]

    const [commission, setCommission] = useState<number>(() => {
        return commissions[0].value
    });
    
    const message = {
        success: 'Transaction successful',
        failed: 'Transaction Failed',
        processing: 'We are processing your request, please wait.'
    }

    const [contribution, setContribution] = useState<any>(1);

    const [terms, agreeTerms] = useState(false);

    const [userTerms, showUserTerms] = useState<boolean>(false);

    useIonViewWillLeave(() => {
        setDisabled(false)
        setTransaction('processing')
        setShowSubmit(false)
        setAgreeToTerms(false)
    })

    useEffect(() => {
        getOrgList();
        return () => { };
    }, [])

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            setLocalState(stateData)
        }

        return () => {
            mounted = false
        }
    }, [stateData])

    const getOrgList = async () => {
        let orgs = await fetchOrgList();
        setOrgList(orgs.message);
    }

    const updateOrg = (value: any) => {
        setOrgChoice({ pickOrg: value })
        if (value !== "other") {
            let form = donateData;
            form.beneficiary_type = 'organisation';
            form.altOrg = null;
            form.pickOrg = value;
            setDonateData(form);
        } else {
            let form = donateData;
            form.pickOrg = null;
            form.beneficiary_type = "other";
            form.altOrg = value;
            setDonateData(form);
        }
    }
    const updateDate = (event: any) => {
        let form = donateData;
        form.date = event.target.value;
        setDonateData(form);
    }
    const updateFreq = (event: any) => {
        let form = donateData;
        form.freq = event.target.value;
        setDonateData(form);
    }
    const updateAmount = (event: any) => {
        let form = donateData;
        form.amount = event.target.value;
        setDonateData(form);
    }
    const updateAnom = (event: any) => {
        let form = donateData;
        form.anom = event.target.checked;
        setDonateData(form);
    }

    const updateAgreement = (event: any) => {
        event.preventDefault();
        let current = agreeToTerms;
        setAgreeToTerms(!current);
    }
    const [step, setStep] = useState(0);

    const toggleContribution = () => {
        let current = contribution;
        setContribution(current !== 0 ? 0 : 1);
    }

        /*Close open user terms  */
        const toggleUserTerms = () => {
            let current = userTerms;
            showUserTerms(!current);
        }

    const onSubmit = (event: any) => {
        let state = {
            data: donateData
        }
        event.preventDefault();
        if (method === "direct") {
            //setStep(0);
            //setDonateDataState(true)
            state.data.commission=commission
            history.push("../../account/donate_process", state);
        } else if (method === "credit") {

            setDisabled(!disabled)
            setTransaction('processing')
            setShowSubmit(true)

            createDonation({
                title: `${user.firstName}_on_${month}_${day}_number-${Math.floor(Math.random() * 60)}`,
                status: "publish",
                acf: {
                    status: "completed",
                    beneficiary: donateData.pickOrg,
                    beneficiary_type: donateData.beneficiary_type,
                    anonymous: `${donateData.anom}`,
                    amount: stateData.data.amount,
                    commission: 0,
                    date: ymd(donateData.date),
                    donation_method: "sw_account",
                    frequency: donateData.freq
                }
            }).then(
                m => {
                    if (m?.message) {
                        setTransaction('success');
                        setTimeout(() => {
                            history.push("../../account/start")
                        }, 300)
                    }
                }
            )
        } else {
            return
        }
        //if method is direct -> go to pay component

        //if method is credit -> debit account
    }

    const submitWithAccountFundraiser = (event: any) => {

        //
        event.preventDefault();
        setDisabled(!disabled)
        setTransaction('processing')
        setShowSubmit(true)

        //
        createDonation({
            title: `${user.firstName}_on_${month}_${day}_number-${Math.floor(Math.random() * 60)}`,
            status: "publish",
            acf: {
                status: "completed",
                beneficiary: stateData.data.pickOrg,
                beneficiary_type: stateData.data.beneficiary_type,
                anonymous: `${donateData.anom}`,
                amount: stateData.data.amount,
                commission: 0,
                date: minDate,
                donation_method: "sw_account",
                frequency: 'single'
            }
        }).then(
            m => {
                if (m?.message) {
                    setTransaction('success')
                    setTimeout(() => {
                        history.push("../fundraise")
                    }, 300)
                }
            }
        )
    }

    const onSubmitStep = (event: any) => {
        event.preventDefault();
        setStep(1);
    }

    const SubmitMessage = () => {

        return (
            <>

                <IonBackdrop className="submitMessage">
                    <IonRow >
                        <IonCol size="12" sizeMd="6" offsetMd="3">
                            <IonCard className="ion-text-center">
                                <IonCardContent>

                                    {transaction === "processing" && message.processing}
                                    {transaction === "success" && message.success}
                                    {transaction === "failed" && message.failed}
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>

                </IonBackdrop>

            </>
        )

    }

    const DonateWithPmtMethods = () => {
        return (
            <>
            {!userTerms?
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <h1>{siteText.donateDirectlyStartTitle}</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-margin-top" sizeSm="12" sizeMd="8">
                                <form onSubmit={e => onSubmit(e)}>
                                    
                                    <IonLabel position="stacked">{siteText.donateDirectlyStartAmountLabel}</IonLabel>
                                    <IonInput className="ion-margin-bottom ion-margin-top" value={donateData.amount} onIonChange={updateAmount} placeholder={siteText.donateDirectlyStartAmountPlh} min="0" type="number"></IonInput>
                                    {/*<h4>Subtotal with tip: {donateData.amount ? (+donateData.amount+(donateData.amount*commission)) : 0} ---{commission}CHF</h4>*/}
                                    
                                    <p>{siteText.donateDirectlyPayTipRequest}</p>
                                    <IonRadioGroup style={{display:'flex'}} className="ion-margin-bottom" value={commission} onIonChange={(e:any)=>setCommission(e.detail.value)}>
                                        {commissions.map((m, key) =><IonItem className="ion-margin-end" lines="none" key={key}><IonLabel className="ion-margin-end">{m.label}</IonLabel> <IonRadio  value={m.value}></IonRadio></IonItem>)}
                                    </IonRadioGroup>

                                    <IonLabel position="stacked">{siteText.donateDirectlyStartBeneficiaryLabel}</IonLabel>
                                    <IonSelect className="ion-margin-bottom ion-margin-top" value={orgChoice.pickOrg} okText={siteText.donateDirectlyStartBeneficiaryConfirm} cancelText={siteText.donateDirectlyStartBeneficiaryCancel} onIonChange={(e) => updateOrg(e.detail.value)}>
                                        <IonSelectOption value="other">{siteText.donateDirectlyStartBeneficiaryInputOpt}</IonSelectOption>
                                        {orgList?.map((m: any, key) => {
                                            return <IonSelectOption key={key} value={m.id}>{m.title.rendered}</IonSelectOption>
                                        })}


                                    </IonSelect>
                                    {
                                        (orgChoice.pickOrg === 'other')
                                            ? (<>
                                                <IonLabel position="stacked">{siteText.donateDirectlyStartBeneficiarySuggest}
                                                </IonLabel>
                                                <IonInput className="ion-margin-bottom ion-margin-top" placeholder={siteText.donateDirectlyStartBeneficiarySuggestPlh} required={(orgChoice.pickOrg === "other") ? true : false}></IonInput>
                                            </>)
                                            : ''
                                    }

                                    <IonItem lines="none" className="borderedInput">
                                        <IonLabel>
                                            {siteText.donateDirectlyStartAnonymousCheck}
                                        </IonLabel>
                                        <IonCheckbox onIonChange={updateAnom}  slot="end" />
                                    </IonItem>
                                    <IonCol sizeMd="4" >

                                        {/**contributon 
                                        <IonItem lines="none">
                                            <IonLabel className="ion-text-wrap" ></IonLabel>
                                            <IonCheckbox checked={contribution === 1} onIonChange={toggleContribution} />
                                        </IonItem>*/}

                                 
                                    </IonCol>
                                    <IonCol sizeMd="4">
                                        <IonItem lines="none">
                                            <IonLabel className="ion-text-wrap"> <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateDirectlypayConfirm}</Link> </IonLabel>
                                            <IonCheckbox checked={terms} onIonChange={() => { agreeTerms(!terms) }} />
                                        </IonItem>
                                    </IonCol>
                                    <IonButton slot="end" className="ion-margin-top" type="submit">
                                        {siteText.donateDirectlyStartSubmitTxt}
                                    </IonButton>
                                </form>
                            </IonCol>
                        </IonRow>
                    </IonGrid>:
                <IonGrid>
                    <UserTerms goBack={toggleUserTerms}></UserTerms>
                </IonGrid>
            }
            </>
        )
    }


    const DonateToFundraiserWithCredit = () => {
        return (
            <>
                <IonContent>
                    {showSubmiting && <SubmitMessage />}
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <h1>{siteText.fundraiseDonateStepTitle.replace("%%title%%", localState?.data.title)}</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <form onSubmit={e => submitWithAccountFundraiser(e)}>

                                    <IonLabel position="stacked">{siteText.fundraiseDonateStepAmountLabel}</IonLabel>
                                    <IonItem lines="none" className="cashField ion-margin-top ion-margin-bottom">
                                        <IonInput
                                            disabled value={localState?.data ? localState?.data.amount : ''}
                                            onIonChange={updateAmount}
                                            placeholder={siteText.fundraiseDonateStepAmountPhl} min="0" type="number">
                                        </IonInput>
                                        <IonText>CHF</IonText>
                                    </IonItem>

                                    <IonItem lines="none" className="borderedInput">
                                        <IonLabel>
                                            {siteText.fundraiseDonateStepAnonymous}
                                        </IonLabel>
                                        <IonCheckbox onIonChange={updateAnom} checked={false} slot="end" />
                                    </IonItem>

                                    <IonItem lines="none" className="borderedInput ion-margin-top">
                                        <IonLabel>
                                            {siteText.fundraiseDonateStepTermsConfrim}</IonLabel>
                                        <IonCheckbox checked={agreeToTerms} onIonChange={updateAgreement} />

                                    </IonItem>
                                    <IonButton disabled={disabled || !agreeToTerms} slot="end" className="ion-margin-top" type="submit">
                                        {siteText.fundraiseDonateStepPrimary}
                                    </IonButton>

                                </form>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                </IonContent>
            </>
        )
    }

    const DonateWithCredit = () => {
        return (
            <>
                <IonContent>
                    {showSubmiting && <SubmitMessage />}
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <h1>{siteText.donateUseCreditStartTitle}</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol sizeMd="8">
                                <IonRow className="formProgressIndicator">
                                    <IonCol className="ion-text-center" sizeXs="6">
                                        <IonChip className={step < 1 ? "active" : ''}>
                                            <IonLabel>1</IonLabel>
                                        </IonChip>
                                    </IonCol>
                                    <IonCol className="ion-text-center" sizeXs="6">
                                        <IonChip className={step > 0 ? "active" : ''} >
                                            <IonLabel>2</IonLabel>
                                        </IonChip>
                                    </IonCol>
                                </IonRow>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-margin-top" sizeSm="12" sizeMd="8">
                                <FormSteps></FormSteps>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                </IonContent>
            </>
        )
    }


    const View = () => {
        if (method === "direct") {
            //Donate to organisation directly
            return (<DonateWithPmtMethods />)
        } else if (method === "credit") {
            //Donate to organisation with credit
            return (
                <DonateWithCredit></DonateWithCredit>
            )
        } else {
            // Donate to campaing with credit
            return (
                <DonateToFundraiserWithCredit />
            )
        }
    }

    const FormSteps = () => {
        if (step > 0) {
            return (
                <form onSubmit={onSubmit}>

                    <IonLabel position="stacked">{siteText.donateUseCreditDetailsFrequencyTitle}</IonLabel>

                    <IonRadioGroup className="ion-margin-top ion-margin-bottom" value="single" onIonChange={updateFreq}>
                        <IonItem lines="none">
                            <IonLabel>{siteText.donateUseCreditDetailsMonthly}</IonLabel>
                            <IonRadio slot="start" value="monthly"></IonRadio>
                        </IonItem>

                        <IonItem lines="none">
                            <IonLabel>{siteText.donateUseCreditDetailsSingle}</IonLabel>
                            <IonRadio slot="start" value="single"></IonRadio>
                        </IonItem>
                    </IonRadioGroup>
                    <p className="ion-margin-bottom smallText">{siteText.donationSubscriptionWarning}</p>

                    <div className="ion-margin-top ion-margin-bottom">
                        <IonLabel position="stacked">{siteText.donateUseCreditDetailsExecuteLabel}</IonLabel>
                        {/*<IonDatetime className="ion-margin-top" onIonChange={updateDate} showDefaultButtons={false} showClearButton={true} clearText={siteText.donateUseCreditDetailsExecuteClear} cancelText={siteText.donateUseCreditDetailsExecuteCancel} presentation="date" mode="ios" min={minDate} max="2025-12-09" yearValues="2022" doneText={siteText.donateUseCreditDetailsExecuteConfirm}></IonDatetime>*/}
                        <IonInput className="ion-margin-top" type="date" onIonChange={updateDate} min={minDate}></IonInput>
                    </div>
                    <IonItem lines="none" className="borderedInput ion-margin-top">
                        <IonLabel>
                            {siteText.donateUseCreditDetailsTermsConfrim}</IonLabel>
                        <IonCheckbox checked={agreeToTerms} onIonChange={updateAgreement} />

                    </IonItem>
                    <IonButton disabled={disabled || !agreeToTerms} slot="end" className="ion-margin-top" type="submit">
                        {siteText.donateUseCreditDetailsPrimary}
                    </IonButton>


                </form>
            )
        } else {
            return (
                <form onSubmit={onSubmitStep}>
                    <IonLabel position="stacked">{siteText.donateUseCreditDetailsAmountLabel}</IonLabel>

                    <IonItem lines="none" className="cashField ion-margin-top ion-margin-bottom">
                        <IonInput onIonChange={updateAmount}
                            disabled value={localState?.data ? localState?.data.amount : ''}
                            placeholder={siteText.donateUseCreditDetailsAmountPhl} min="0" type="number"></IonInput>
                        <IonText>CHF</IonText>
                    </IonItem>

                    <IonLabel>{siteText.donateUseCreditDetailsBenLabel}</IonLabel>
                    <IonSelect className="ion-margin-bottom ion-margin-top" value={orgChoice.pickOrg} okText="Ok" cancelText="Dismiss" onIonChange={(e) => updateOrg(e.detail.value)}>
                        <IonSelectOption value="other">{siteText.donateUseCreditDetailsBeneficiaryOpt}</IonSelectOption>
                        {orgList?.map((m: any, key) => {
                            return <IonSelectOption key={key} value={m.id}>{m.title.rendered}</IonSelectOption>
                        })}


                    </IonSelect>
                    {
                        (orgChoice.pickOrg === 'other')
                            ? (<>
                                <IonLabel position="stacked">{siteText.donateUseCreditDetailsBeneficiaryAltLabel}
                                </IonLabel>
                                <IonInput className="ion-margin-bottom ion-margin-top" placeholder={siteText.donateUseCreditDetailsAltBeneficiaryPlh} required={(orgChoice.pickOrg === "other") ? true : false}></IonInput>
                            </>)
                            : ''
                    }
                    <IonItem lines="none" className="borderedInput">
                        <IonLabel>
                            {siteText.donateUseCreditDetailsAnonymousCheck}
                        </IonLabel>
                        <IonCheckbox onIonChange={updateAnom} checked={false} slot="end" />
                    </IonItem>
                    <IonButton className="ion-margin-top" type="submit">
                        {siteText.donateUseCreditDetailsNext}
                    </IonButton>
                </form>
            )
        }
    }
    return <View />



}

export default DonateComponent;